import { notFound, rootRouteId } from '@tanstack/react-router'

/** Whether a player or a parent may register on their own. Shut in the first release, the same in
 *  staging and prod: a constant, not a setting (docs/adr/0013-la-prima-release-registra-solo-le-societa.md). */
export const PERSONS_MAY_SIGN_UP = false

// Indirection with a purpose, as `activationReader`: the tests of the two shut flows turn the
// switch on, and nothing can rebind a constant. Read on every navigation, never once at load.
export const signUpPolicy = {
  personsMaySignUp: (): boolean => PERSONS_MAY_SIGN_UP,
}

/** The `beforeLoad` of a person's sign-up: while it is shut the path answers as one that does
 *  not exist, from the root, so the entrance's sheet does not open on it. */
export function requirePersonsMaySignUp(): void {
  if (!signUpPolicy.personsMaySignUp()) throw notFound({ routeId: rootRouteId })
}
